<script>
  import { map } from 'lodash'
  import IconArrowDown from '@/components/IconArrowDown'
  import CustomSharingOptions from '@/components/CustomSharingOptions.vue'


  export default {
    name: 'AppHeader',
    components: {
      IconArrowDown,
      CustomSharingOptions
    },
    computed: {
      countries_id() {
        return map(this.$store.state.players.all, 'country_iso_3')
      }      
    }
  }
</script>

<template>
  <div class="app-header border-bottom pb-3 pb-md-5">
    <BContainer>
      <BRow class="justify-content-center ">
        <BCol cols="12" md="6" class="player-item text-center">
          <h1 class="app-header__project">
            <RouterLink :to="{ name: 'list' }">
              <span>{{ $t('list.pre_title') }}</span>
              {{ $t('list.title') }}
            </RouterLink>
          </h1>
        </BCol>
      </BRow>
      <BRow class="justify-content-center">
        <BCol cols="12" md="10" class="player-item">
          <div class="app-header__logo d-flex">
            <RouterLink :to="{ name: 'list' }">
              <img alt="$config.get('app.name')" src="../assets/pp_logo.png" />
            </RouterLink>            
          </div>
        </BCol>
      </BRow>
      <BRow class="justify-content-center">
        <BCol cols="12" md="8" class="player-item">
          <div class="text-center mb-3">
            <CustomSharingOptions class="justify-content-center" :title="`${$t('list.pre_title')}`" url="https://icij.org" />
          </div>
          <div class="app-header__intro" v-html="$t('list.intro')"></div>
          <div class="text-center d-block d-md-none">
            <IconArrowDown :width="48" :height="48" />
          </div>
        </BCol>
      </BRow>
    </BContainer>
  </div>
</template>

<style lang="scss" scoped>
  .app-header {
    position: relative;
    margin-bottom: 30px;
    padding: #{'min(150px, 10vh)'} 0 0 0;

    &__group {
      width: 100%;
      max-width: 720px;
      opacity: 0;
      animation: logoUp 1.2s forwards 1 ease-in-out;
    }

    .image-cover {
      width: 65%;
      opacity: 0.7;
    }

    &__logo {
      img {
        width: 100%;
      }
    }

    &__project {      
      color: var(--app-color-black);
      font-family: var(--headings-type-writer);
      font-size: 71px;
      margin: 0;
      

      @media (max-width: 767.98px) {
        font-size: 51px;
      }

      span {
        display: block;
        font-size: 41px
      }

      a {
        color: inherit;
        text-decoration: none;
      }
    }

    &__intro {
      color: var(--app-color-black);
      font-size: 1.4em;
      text-align: center;
    }

    &__project {
      font-weight: bold;
    }

    &__app {
      font-weight: normal;
    }

    @keyframes logoUp {
      to {
        transform: translateY(0);
        opacity: 1;
      }
    }
  }
</style>
